import { styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

export const MissionListContainer = styled.div<{ showFiltersPanelForm: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;

  ${getMediaQuery('mobile', 'tablet')} {
    display: ${({ showFiltersPanelForm }) => (showFiltersPanelForm ? 'none' : 'flex')};
  }
`;
